import axios from "const/axios";
import { API_URL } from "const/constants";

const normalizePage = (raw) => ({
  content: raw?.content ?? [],
  totalItems: Number(raw?.totalItems ?? 0),
  totalPages: Number(raw?.totalPages ?? 0),
});

export const fetchRplClientsPage = async ({
  pageIndex = 0,
  pageSize = 20,
  search = "",
  status = "All",
  paymentStatus = null,
} = {}) => {
  const res = await axios.get(`${API_URL}/rpl/clients/page`, {
    params: {
      page: pageIndex,
      size: pageSize,
      ...(search?.trim() ? { search: search.trim() } : {}),
      ...(status && status !== "All" ? { status } : {}),
      ...(paymentStatus ? { paymentStatus } : {}),
    },
  });
  return normalizePage(res?.data?.data);
};

export const fetchRplRecordsByClientId = async (clientId) => {
  const res = await axios.get(`${API_URL}/rpl/client/${clientId}/records`);
  return res?.data?.data ?? [];
};

export const fetchVisaClientsPage = async ({
  pageIndex = 0,
  pageSize = 20,
  search = "",
  type = "All",
} = {}) => {
  const res = await axios.get(`${API_URL}/visa-applications/clients/page`, {
    params: {
      page: pageIndex,
      size: pageSize,
      ...(search?.trim() ? { search: search.trim() } : {}),
      ...(type && type !== "All" ? { type } : {}),
    },
  });
  return normalizePage(res?.data?.data);
};

export const fetchVisaRecordsByClientId = async (clientId) => {
  const res = await axios.get(`${API_URL}/visa-applications/client/${clientId}/records`);
  return res?.data?.data ?? [];
};

export const fetchInsuranceClientsPage = async ({
  pageIndex = 0,
  pageSize = 20,
  search = "",
} = {}) => {
  const res = await axios.get(`${API_URL}/insurance/clients/page`, {
    params: {
      page: pageIndex,
      size: pageSize,
      ...(search?.trim() ? { search: search.trim() } : {}),
    },
  });
  return normalizePage(res?.data?.data);
};

export const fetchInsuranceRecordsByClientId = async (clientId) => {
  const res = await axios.get(`${API_URL}/insurance/client/${clientId}/records`);
  return res?.data?.data ?? [];
};

export const fetchSkillClientsPage = async ({ pageIndex = 0, pageSize = 20, search = "" } = {}) => {
  const res = await axios.get(`${API_URL}/skill-assessment/clients/page`, {
    params: {
      page: pageIndex,
      size: pageSize,
      ...(search?.trim() ? { search: search.trim() } : {}),
    },
  });
  return normalizePage(res?.data?.data);
};

export const fetchSkillRecordsByClientId = async (clientId) => {
  const res = await axios.get(`${API_URL}/skill-assessment/client/${clientId}/records`);
  return res?.data?.data ?? [];
};
